<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';

withDefaults(defineProps<{
    open: boolean;
    title: string;
    description?: string;
    widthClass?: string;
    contentClass?: HTMLAttributes['class'];
}>(), {
    description: '',
    widthClass: 'sm:!max-w-3xl',
    contentClass: '',
});

const emit = defineEmits<{ 'update:open': [value: boolean] }>();
</script>

<template>
    <Sheet :open="open" @update:open="emit('update:open', $event)">
        <SheetContent
            side="right"
            class="!flex h-full !w-full max-w-none flex-col gap-0 overflow-hidden bg-background p-0"
            :class="widthClass"
        >
            <SheetHeader class="shrink-0 border-b border-border/70 px-6 py-5 pr-14 text-left">
                <SheetTitle class="text-2xl font-semibold tracking-tight">{{ title }}</SheetTitle>
                <SheetDescription v-if="description" class="text-sm leading-6">{{ description }}</SheetDescription>
            </SheetHeader>
            <div :class="cn('min-h-0 flex-1 overflow-y-auto px-6 py-6', contentClass)">
                <slot />
            </div>
            <div v-if="$slots.footer" class="shrink-0 border-t border-border/70 bg-background/95 px-6 py-4 backdrop-blur">
                <slot name="footer" />
            </div>
        </SheetContent>
    </Sheet>
</template>
